import React from "react";
import { FileText, Users, CheckCircle } from "lucide-react";

const REASONS = [
  {
    icon: FileText,
    title: "One quote",
    body: "Everything priced together—no stitching together vendors.",
  },
  {
    icon: Users,
    title: "One vendor",
    body: "A single point of contact for setup, supplies, and support.",
  },
  {
    icon: CheckCircle,
    title: "One decision",
    body: "Approve once and the full system is on its way to your school.",
  },
];

export default function BundlesWhy() {
  return (
    <section
      data-testid="bundles-why-section"
      className="relative bg-navy text-white py-24 md:py-32 overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)",
          backgroundSize: "64px 64px",
        }}
      />
      <div className="absolute -top-32 -right-32 w-96 h-96 bg-teal/20 rounded-full blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="mb-14 max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-teal mb-4">
            Why bundles
          </div>
          <h2
            data-testid="bundles-why-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-black tracking-tight text-white leading-[1.1]"
          >
            Why Schools Choose{" "}
            <span className="text-teal">Bundles.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6">
          {REASONS.map((r, i) => {
            const Icon = r.icon;
            return (
              <div
                key={r.title}
                data-testid={`bundles-why-reason-${i}`}
                className="group bg-white/5 hover:bg-white/10 border border-white/10 hover:border-teal/40 rounded-2xl p-8 transition-all duration-300"
              >
                <span className="inline-flex w-12 h-12 rounded-xl bg-teal text-white items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <Icon className="w-5 h-5" strokeWidth={2} />
                </span>
                <h3 className="font-serif text-2xl md:text-3xl font-bold text-white mb-3 leading-tight">
                  {r.title}
                </h3>
                <p className="text-sm sm:text-base text-slate-300 leading-relaxed">
                  {r.body}
                </p>
              </div>
            );
          })}
        </div>

        <p className="mt-12 text-lg sm:text-xl text-slate-200 border-l-4 border-teal pl-5 italic max-w-3xl">
          Everything is matched, sized, and ready to go.
        </p>
      </div>
    </section>
  );
}
